module.exports = __webpack_public_path__ + "static/img/img_1.5d2c13e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_1.png
// module id = IpGh
// module chunks = 0